export function translateRole(value) {
  const tranlatedRoles = {
    EXECUTIVE_MANAGER: "Δήμαρχος",
    MANAGER: "Διευθυντής",
    CHIEF: "Προϊστάμενος",
    EMPLOYEE: "Υπάλληλος",
  };
  return tranlatedRoles[value];
}

export function translateWeekdays(value) {
  const WEEKDAYS = {
    MONDAY: "Δευτέρα",
    TUESDAY: "Τρίτη",
    WEDNESDAY: "Τετάρτη",
    THURSDAY: "Πέμπτη",
    FRIDAY: "Παρασκευή",
    SATURDAY: "Σάββατο",
    SUNDAY: "Κυριακή",
  };
  return WEEKDAYS[value];
}
